import { useAuth0 } from "./react-auth0-wrapper";

const roles = {
  ADMIN: "admin",
  AGENTE: "agente",
  BACKOFFICE: "backoffice",
  CENTRALE: "centrale",
  COLLAUDO: "collaudo",
  DEALER: "dealerusr",
  MARKETING: "marketing",
  SERVICE: "service",
  VENDITORE: "venditore"
};
export default roles;

export const getRolesDomain = () => {
  return Object.keys(roles).map(key => ({
    label: roles[key],
    value: roles[key]
  }));
};
